<template>
  <div class="subtitleVipDrop">
    <div class="title">
      <span>加入VIP可享受</span>
      <div class="discount" v-if="haveVipActivity">{{activityType}}</div>
    </div>
    <div class="list-body">
      <div class="body">
        <img
          :style="{'width':'16.6px','height':'18.8px'}"
          src="../../../static/svg/topNav/watermark.svg"
          alt
        />
        <div class="details">
          <span class="details-title">视频无水印</span>
          <span class="details-content">个人VIP最高36次无水印</span>
        </div>
      </div>

      <div class="body">
        <img
          :style="{'width':'18px','height':'18px'}"
          src="../../../static/svg/topNav/video.svg"
          alt
        />
        <div class="details">
          <span class="details-title">视频下载本地</span>
          <span class="details-content">本地视频支持多渠道分发</span>
        </div>
      </div>
    </div>
    <div class="bottom-grid">
      <span class="time-limit-ad" v-if="haveVipActivity">{{activityTitle}}</span>
      <div @click="joinVip()" class="join-vip">立即加入VIP</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "subtitleVipDrop",
  data() {
    return {
      haveVipActivity: false,
      activityType: "",
      activityTitle: ""
    };
  },
  props: {},
  components: {},
  methods: {
    joinVip() {
      this.$util.localStorage.set('sensorWebPurchaseVipSource', {
        val: {
          routename: 'tool',
          page: '编辑器-会员升级'
        }
      });
      this.$util.localStorage.set('sensorWebPayVipSource', {
        val: {
          routename: 'tool',
          page: '编辑器-会员升级'
        }
      });
      this.$util.localStorage.set('saPurchaseSource', {
        fullPath: '/tool'
      });
      window.open("/pricing/vipsolo", "_blank");
      this.$bus.emit("subtitlePopup", {
        name: "vipPayment",
        msg: "请在相应的付款页面进行操作",
        btnClose: "遇到问题",
        btnMsg: "付款成功",
        fs: "payPriceEvent_vue",
        msgType: 2,
        type: 2
      });
    },
    getActivityContent(vipActivity) {
      //如果discountCount不等10.00且attached不等于0，那么优先展示attached
      if (vipActivity.attached && vipActivity.attached > 0) {
        this.activityType = "买1送" + vipActivity.attached + "个月";
        let averagePrice =
          vipActivity.price / ((12 + vipActivity.attached) * 31);
        averagePrice = parseFloat(averagePrice.toFixed(1));
        this.activityTitle =
          "限时买1送" +
          vipActivity.attached +
          "个月,每天低至" +
          averagePrice +
          "元";
        this.haveVipActivity = true;
      } else if (
        vipActivity.discountCount &&
        vipActivity.discountCount > 0 &&
        vipActivity.discountCount < 10
      ) {
        this.activityType =
          "限时" + parseFloat(vipActivity.discountCount) + "折";
        let averagePrice = vipActivity.price / (12 * 31);
        averagePrice = parseFloat(averagePrice.toFixed(1));
        this.activityTitle =
          "限时特惠" +
          parseFloat(vipActivity.discountCount) +
          "折,每天低至" +
          averagePrice +
          "元";
        this.haveVipActivity = true;
      }
    },
    async getVipActivity() {
      const vm = this;
      this.$http.get("/api/user/vipLevelInfo?levelType=0").then(res => {
        if (res.data.code === 200) {
          let datas = res.data.data;
          for (const i in datas) {
            let data = datas[i];
            for (const j in data) {
              let info = data[j];
              if (info.levelType == 0 && info.month == 12) {
                vm.getActivityContent(info);
              }
            }
          }
        }
      });
    }
  },
  created() {
    this.getVipActivity();
  },
  watch: {},
  computed: {}
};
</script>

<style scoped lang='scss'>
.subtitleVipDrop {
  display: flex;
  flex-direction: column;
  height: 226px;
  padding: 15px 20px;
  background-color: #fff;
  border: 0 solid black;

  .title {
    display: flex;
    align-items: center;
    height: 20px;
    color: #474261;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
    .discount {
      display: inline-block;
      min-width: 50px;
      height: 14px;
      padding-left: 10px;
      padding-right: 10px;
      margin-left: 8px;
      color: #fff;
      font-size: 10px;
      font-weight: normal;
      line-height: 14px;
      text-align: center;
      background: #ea3d45;
      border-radius: 4px;
    }
  }
  .list-body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    .body {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex: 1;
      width: 100%;
      .icon {
        width: 18px;
        height: 18px;
        margin-right: 14px;
      }
      .details {
        flex-grow: 1;
        margin-left: 14px;
         > span {
          display: inline-block;
          width: 100%;
          height: 50%;
          font-size: 12px;
          line-height: 50%;
          text-align: left;
        }
        .details-title {
          color: #474261;
          font-weight: bold;
        }
        .details-content {
          color: #737596;
        }
      }
    }
  }
  .bottom-grid {
    position: relative;
    height: 57px;
    .time-limit-ad {
      margin-bottom: 7px;
      color: #bb9029;
      font-size: 12px;
    }
    .join-vip {
      position: absolute;
      bottom: 0;
      width: 218px;
      height: 32px;
      color: #866923;
      font-size: 14px;
      line-height: 32px;
      background: linear-gradient(
      -4deg,
      rgba(227, 174, 47, 1) 0%,
      rgba(254, 221, 144, 1) 100%
      );
      border-radius: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitleVipDrop.vue